export interface GzChipsItem {
  text: string;
  icon?: string;
  color?: string;
  disabled?: boolean;
  removable?: boolean;
  notSelectable?: boolean;
  boldSubtext?: string;
  readonly?: boolean;
}

export enum ChipEvents {
  REMOVE = 'removeChip',
}

export enum ChipColor {
  DEFAULT = 'default',
  PRIMARY = 'primary',
  NEGATIVE = 'negative',
}
